import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { degreeOccupancyTime } from "../widgets/Charts";
import { windowsActive } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";
import ByDate from "./Reserves/ByDate";
import Segment from "./Reserves/Segment";
import Channel from "./Reserves/Channel";
import Budget from "./Reserves/Budget";
import Occupied from "./Reserves/Occupied";
import Oos from "./Reserves/Oos";
import RoomStock from "./Reserves/RoomStock";
import Availably from "./Reserves/Availably";
import OverBooked from "./Reserves/OverBooked";

class Reserves extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data_degree_occupancy_time : {
                month_names: [],
                type_names : [],
                values : [],
            },
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            hidden_wdg_time : "show-widget complete",
            hidden_wdg_room_nights : "show-widget complete",
            hidden_wdg_adr : "show-widget complete",
            hidden_wdg_revenue : "show-widget complete",
            hidden_wdg_revpar : "show-widget complete",
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
        this.setSegments = this.setSegments.bind(this);
        this.getAgencies = this.getAgencies.bind(this);
        this.activeSegment = this.activeSegment.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.setDefaultValuesModule = this.setDefaultValuesModule.bind(this);
        this.callMainRequest = this.callMainRequest.bind(this);
    }
    setSegments(segments, key_time, filt) {
        let self = this;
        
        const status  =  (Object.keys(filt).length > 0) ? "active" : "inactive";
        if (segments !== null) {
            self.setState({
                filters_segment: segments,
                filter_month_active: status,
                key_time: filt,
                filter_ms_active : "active"
            }, function () {
                self.props.app.mainRequest();
            })
        } else {
            self.setState({
                filters_segment: [],
                filter_month_active: status,
                filter_segment_active: "inactive",
                statics_channels: {},
                segmentActive : {},
                filter_ms_active : "inactive"
            }, function(){
                self._widgetSegment.setState({
                    segmentActive : {}
                }, function(){
                    self.props.app.mainRequest();
                })
            })
        }
    }
    getAgencies(status, segmentActive) {
        let self = this;
        if (status === 'active') {
            self.setState({
                statics_channels: Object.assign({}, self.state.filters_channels),
                filter_segment_active : "active",
                segmentActive : segmentActive
            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
                
            })
        } else {
            self.setState({
                statics_channels : {},
                filter_segment_active : "inactive",
                segmentActive : {}

            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
            })
        }
    }
    activeSegment(status) {
        if (status === "inactive") {
            this.setState({
                filters_channels: [],
                statics_channels: []
            });
        }
        this.setState({
            filter_segment_active: status
        })
    }
    getDefaultValues(){
        this.setState({
            data_degree_occupancy_time : {
                month_names: [],
                type_names : [],
                values : [],
            },
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            hidden_wdg_time : "show-widget complete",
            hidden_wdg_room_nights : "show-widget complete",
            hidden_wdg_adr : "show-widget complete",
            hidden_wdg_revenue : "show-widget complete",
            hidden_wdg_revpar : "show-widget complete",
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        })
    }
    setDefaultValuesModule(){
        let self = this;
        self.setState(self.getDefaultValues(), function(){
            self._widgetByDate.setState(self._widgetByDate.getDefaultValues());
            self._widgetSegment.setState(self._widgetSegment.getDefaultValues());
        });
    }
    callMainRequest(params = {}){
        this.props.app.mainRequest(params)
    }
    getOptionTypeBar = (chart, values_calendar) => {
        let self = this;
        return degreeOccupancyTime(this.state.data_degree_occupancy_time);
    }
    componentWillReceiveProps(props) {
        let isset = Object.keys(props.response_request).length > 0;
        if (isset){
            let result = props.response_request["result"];
            this.setState({ 
                data_degree_occupancy_time  : result["degree_occupancy_time"],
                action_component : "other"
            })

            let response = props.response_request["result"]["data_table_occupancy"]
            let self = this;
            if(Object.keys(response).length > 0){
                self.setState(function (prevState) {                
                    let results = {}
                    if (self.state.filters_segment.length > 0) {
                        let filters_channels_aux = {};
                        Object.keys(response.result).map(function(key) {
                            let rr = response.result[key];
                            filters_channels_aux[key] = {}
                            Object.keys(rr).map(function(key_two) {
                                filters_channels_aux[key][key_two] = {};
                                if(key_two !== "totals"){
                                    //let rr2 = rr[key_two]["channels"]
                                    //Object.keys(rr2).map(function(key_three){
                                        //filters_channels_aux[key][key_two][key_three] = rr2[key_three]
                                    //});
                                }else{
                                    filters_channels_aux[key][key_two] = rr[key_two]
                                }
                            });
                        })

                        results = {
                            filters_channels: filters_channels_aux,
                            statics_segments_aux: response.result,
                            statics_segments: response.result
                        }
                    } else {
                        results = {
                            statics_channels: [],
                            statics_segments: [],
                            statics_aux: response.result,
                            statics: response.result,
                            total_widgets: response.totals
                        }
                    }
                    return results;
                }, function () {
                    let filt;
                    filt = self._widgetByDate.state.current_key_time;
                    let state_statics = Object.assign({}, self.state.statics);
                
                    Object.keys(state_statics).map(function(key){
                        if(filt[key] !== undefined){
                            state_statics[key].state = "active";
                        }else{
                            state_statics[key].state = "inactive";
                        }
                    })
                    self.setState({
                        statics_aux : state_statics,
                        statics : state_statics,
                    },function(){
                        if(Object.keys(self._widgetSegment.state.segmentActive).length > 0){
                            self.getChannels("active", self._widgetSegment.state.segmentActive)
                        }
                    })
                })
            }
        }
    }
    render() {
        return (
            <section>
                <div className={"datagrid-widget occupancy-by-availability"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">DEGREE OF OCCUPATION AND AVAILABILITY</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="container-review">
                                    <ReactEcharts
                                        option={windowsActive(this.props, "occupancy", "reserves") === true ? this.getOptionTypeBar("data_rate_availability") : {}}
                                        notMerge={true}
                                        lazyUpdate={true}
                                        theme={"theme_name"}
                                        onChartReady={this.onChartReadyCallback}
                                        ref={(e) => { this._echarRoomType = e; }}
                                    />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className="table-split occupancy">
                    <ByDate
                        layout={this}
                        app={this.props.app}
                        ref={(child) => { this._widgetByDate = child; }}
                    />

                    <div className={"container-aux " + this.state.filter_ms_active}>
                        <Segment
                            layout={this}
                            app={this.props.app}
                            ref={(child) => { this._widgetSegment = child; }}
                        />
                        <Channel
                            app={this.props.app}
                            layout={this}
                            ref={(child) => { this._widgetChannel = child; }}
                        />
                    </div>
                    <Budget
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetBudget = child; }}
                    />  
                    <RoomStock
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetRoomStock = child; }}
                    />  
                    <OverBooked
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetOverBooked = child; }}
                    />  
                    <Oos
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetOos = child; }}
                    />  
                    <Occupied
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetOccupied = child; }}
                    /> 
                    <Availably
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetAvailably = child; }}
                    /> 
                </div>   
            </section>
        )
    }
}

export default Reserves



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/views/Reserves.js